import {createAction} from '@reduxjs/toolkit'
import {isEventDetailsPageHiddenInternal} from '@wix/wix-events-commons-statics'
import {Routes} from '../../../../commons/enums'
import * as navigation from '../../../../commons/services/navigation'
import {getNoEventsPage} from '../selectors/component'
import {getNoUpcomingEventsPageId} from '../selectors/navigation'
import {createAsyncAction} from '../services/redux-toolkit'
import {DetailedEvent, RouteParams} from '../types/state'

export const navigateToDetailsPage = createAsyncAction<void, {event: DetailedEvent}>(
  'NAVIGATE_TO_DETAILS_PAGE',
  async ({event}, {dispatch, extra: {wixCodeApi}}) => {
    dispatch(navigateToDetailsPageClicked())

    const detailsPageEnabled = !isEventDetailsPageHiddenInternal(event.event)

    await navigation.navigateToDetailsPage(event.event, detailsPageEnabled, wixCodeApi)
  },
)

export const updateNoEventsUrl = createAsyncAction<{url: string; pageId: string}, void>(
  'UPDATE_NO_EVENT_URL',
  async (_, {getState, extra: {wixCodeApi, flowAPI}}) => {
    const page = (await getNoEventsPage({wixCodeApi, flowAPI, state: getState()})) as any
    const url = `${wixCodeApi.location.baseUrl}${page.prefix ? `/${page.prefix}` : ''}${page.url}`

    return {
      url,
      pageId: page.id,
    }
  },
)

export const navigateToDetailsPageClicked = createAction('NAVIGATE_TO_DETAILS_PAGE')

export const internalNavigate = createAction<{route: Routes; params?: RouteParams}>('INTERNAL_NAVIGATE')

export const navigateToNoUpcomingEventsUrl = createAsyncAction<void, void>(
  'NAVIGATE_TO_NO_UPCOMING_EVENTS_URL',
  async (_, {getState, extra: {wixCodeApi}}) =>
    wixCodeApi.location.navigateTo({pageId: getNoUpcomingEventsPageId(getState())}),
)
